import { useEffect, useRef, useState } from "react";
import { Nil } from "cy-util";

/**
 *
 */
export function useRefValue<TEle>() {
  const ref = useRef<TEle>(null);
  const [state, setState] = useState<TEle | Nil>(null);

  useEffect(() => {
    setState(ref.current);
  }, []);
  return { ref, refValue: state };
}
